module.exports = __webpack_public_path__ + "img/RTF.60784b6.svg";